<template>
  <div class="product-description  pb-10" v-if="tabs.length > 0">
    <div v-if="$vuetify.breakpoint.smAndUp">
      <v-tabs
        v-model="selectedTab"
        grow
        slider-size="0"
        :show-arrows="$vuetify.breakpoint.xs"
      >
        <v-tab
          v-for="(tab, idx) in tabs"
          :key="idx"
          :class="{ 'mr-1': idx < tabs.length - 1 }"
          class="text-h5 text-uppercase font-weight-bold"
        >
          {{ tab.title }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="selectedTab">
        <v-tab-item v-for="tab in tabs" :key="tab.title" :class="tab.cssClass">
          <div
            v-for="item in tab.items"
            :key="item.title"
            :class="item.cssClass"
          >
            <div
              class="text-h5 text-uppercase font-weight-bold"
              v-if="item.title"
            >
              {{ item.title }}
            </div>
            <div
              class="text-h5 content"
              v-for="path in item.paths"
              :key="path.key"
            >
              <component
                :is="path.template || 'DefaultTpl'"
                :content="path.content"
                :append="path.append"
              />
            </div>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <v-expansion-panels v-else accordion flat tile :focusable="selectedTab">
      <v-expansion-panel
        v-for="tab in tabs"
        :key="tab.title"
        :class="tab.cssClass"
      >
        <v-expansion-panel-header
          class="pa-3 px-sm-3 primary--text primary lighten-3 text-uppercase font-weight-bold"
        >
          <template v-slot:actions>
            <v-icon color="primary">$expand</v-icon>
          </template>
          <div class="text-h5 font-weight-bold" v-html="tab.title" />
        </v-expansion-panel-header>
        <v-expansion-panel-content class="mt-2">
          <div
            v-for="item in tab.items"
            :key="item.title"
            class="pb-4"
            :class="item.cssClass"
          >
            <h4
              v-if="item.title"
              class="mb-1 description-header text-uppercase font-weight-bold"
            >
              {{ item.title }}
            </h4>
            <div
              v-for="path in item.paths"
              :key="path.key"
              class="description-content"
            >
              <component
                :is="path.template || 'DefaultTpl'"
                :content="path.content"
                :append="path.append"
              />
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import get from "lodash/get";
import tabsConfig from "/public/product/descriptionTabsConfig.json";
import kebabCase from "lodash/kebabCase";
import {
  DefaultTpl,
  LabelsTpl,
  ItemsMapTpl,
  TableTpl,
  NameAndValueTpl,
  ValueTpl,
  WarningsTpl,
  ListTpl
} from "./templates";
export default {
  name: "ProductDescription",
  /* eslint-disable vue/no-unused-components */
  components: {
    DefaultTpl,
    LabelsTpl,
    ItemsMapTpl,
    TableTpl,
    NameAndValueTpl,
    ValueTpl,
    WarningsTpl,
    ListTpl
  },
  data() {
    return {
      selectedTab: null,
      productDescriptionTabs: tabsConfig
    };
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    productMetadata: {
      type: Object
    },
    ingredientList: {
      type: Object
    }
  },
  computed: {
    tabs() {
      let tabs = [];
      this.productDescriptionTabs.forEach(tabMeta => {
        let items = [];
        tabMeta.items.forEach(parMeta => {
          let paths = [];
          parMeta.paths.forEach(pathMeta => {
            let content = get(this.product, pathMeta.data || pathMeta);
            let append = pathMeta.append;
            // check if content is empty
            if (content && content !== "<p></p>") {
              // check if table has empty cells
              if (pathMeta.template === "TableTpl") {
                let cells = JSON.parse(content).cells;
                console.log(cells);
                let hasContent = cells.find(c => {
                  return c !== null;
                });
                if (!hasContent) {
                  return;
                }
              }
              if (pathMeta.template === "ValueTpl") {
                let value = JSON.parse(content).value;
                if (!value) {
                  return;
                }
              }
              paths.push({
                key: pathMeta.data || pathMeta,
                content: content,
                template: pathMeta.template,
                append: append
              });
            }
          });
          if (paths.length > 0) {
            items.push({
              title: parMeta.title,
              paths: paths,
              cssClass: get(parMeta, "cssClass", kebabCase(parMeta.title))
            });
          }
        });
        if (items.length > 0) {
          tabs.push({
            title: tabMeta.title,
            items: items,
            cssClass: get(tabMeta, "cssClass", kebabCase(tabMeta.title))
          });
        }
      });

      // additional text at Ingredients tab end
      // let ingredientsTab = tabs.find(t => {
      //   return t.title === "Ingredienti e valori nutrizionali";
      // });
      // if (ingredientsTab) {
      //   ingredientsTab.items.push({
      //     paths: [
      //       { content: this.$t("productDescription.ingredientsAdditionalInfo") }
      //     ]
      //   });
      // }
      return tabs;
    }
  }
};
</script>

<style lang="scss">
.product-description {
  table {
    border-collapse: collapse;
  }
  table,
  tr,
  td,
  th {
    border: 1px solid var(--v-grey-base);
  }
  td,
  th {
    padding: 2px 6px;
  }
  th {
    background-color: var(--v-grey-lighten1);
  }
  .v-tabs {
    position: relative;
    top: 1px;
    z-index: 1;
    .v-item-group {
      height: 46px;
    }
    .v-tab {
      color: $white !important;
      background-color: $primary;
      border-radius: 20px 20px 0 0;
      border: 1px solid $primary;
      border-bottom-color: transparent !important;
      .content {
        line-height: 22px;
        ul {
          padding-left: 0 !important;
        }
        li {
          list-style: none !important;
        }
      }
    }
    .v-tabs-slider-wrapper {
      color: transparent !important;
    }
    .v-tab--active {
      border: 1px solid $gray-border-color;
      color: $primary !important;
      background-color: $white;
    }
  }
  .v-tabs-items {
    background: transparent !important;
    padding: 20px;
    border: 1px solid $gray-border-color;
    .nutritional-info,
    .ingredients,
    .description,
    .producer_info,
    .other,
    .conservation_info,
    .package_info,
    .preparation_info {
      margin-bottom: 10px;
    }
  }

  // @media #{map-get($display-breakpoints, 'xs-only')} {
  //   .v-tabs {
  //     position: relative;
  //     top: 2px;
  //     z-index: 1;
  //     border-radius: 20px 20px 0 0;
  //     border: 1px solid $gray-border-color;
  //     border-bottom-color: $white;
  //     .v-tab {
  //       color: $text-color !important;
  //       // background-color: transparent;
  //       // border-radius: 0;
  //       // border: none;
  //       padding: 0 8px;
  //     }
  //     .v-tab--active {
  //       border: none;
  //       //color: $primary !important;
  //       &::before {
  //         background: transparent;
  //         opacity: 0 !important;
  //       }
  //     }
  //   }
  // }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    .v-expansion-panels {
      .v-expansion-panel:first-child {
        border-top-left-radius: $btn-border-radius;
        border-top-right-radius: $btn-border-radius;
      }
      .v-expansion-panel:last-child {
        .v-expansion-panel-header {
          border-bottom-left-radius: $btn-border-radius !important;
          border-bottom-right-radius: $btn-border-radius !important;
        }
      }
      .v-expansion-panel--active > .v-expansion-panel-header {
        min-height: 48px;
      }
      .v-expansion-panel-content {
        .v-expansion-panel-content__wrap {
          .description-header {
            font-size: 16px;
          }
          .description-content {
            font-size: 14px;
          }
        }
      }
      .v-expansion-panel {
        margin-bottom: 1px;
      }
    }
  }
  .producer_info .text-h5 {
    font-weight: bold;
  }
}
</style>
